import React from "react";

const DraftChat = () => {
  return <div>Chat</div>;
};

export default DraftChat;
